module.exports = __webpack_public_path__ + "img/one_4.8369d068.png";